import React from 'react';
import './ServiceOffline.css';

const ServiceOffline = () => {
  return (
    <div className="offline-wrapper">
      <div className="offline-card">
        <div className="icon-wrap">
          <div className="pulse-ring" />
          <svg className="offline-icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="30" stroke="currentColor" strokeWidth="2.5" />
            <path d="M32 18v16" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
            <circle cx="32" cy="44" r="2.5" fill="currentColor" />
          </svg>
        </div>

        <h1 className="offline-title">Serviço Indisponível</h1>
        <p className="offline-subtitle">
          Este website encontra-se temporariamente fora de serviço.<br />
          Pedimos desculpa pelo inconveniente.
        </p>

        <div className="divider" />

        <p className="offline-hint">
          Se necessita de contactar a FR Pichelaria, por favor tente mais tarde<br />
          ou contacte-nos diretamente.
        </p>

        <div className="status-badge">
          <span className="dot" />
          Serviço offline
        </div>
      </div>

      <p className="offline-footer">© {new Date().getFullYear()} FR Pichelaria</p>
    </div>
  );
};

export default ServiceOffline;
